import { isDevEnvironment } from './env';

/* In here we store the Google Optimize global variables which are the parameters
   for the A/B testing
*/

// the window variable is to be defined.

export const TESTS_DICTIONARY = {
  optimizelyPaymentWarnings: 'optimizelyPaymentWarnings', // Added by story 48096, to be cleaned up by story ?????
  optimizelySuperscriptStaySummarySuite: 'optimizelySuperscriptStaySummarySuite', // Added by story 48791, to be cleaned up by story ?????
  optimizelyTruncateCentsVillas: 'optimizelyTruncateCentsVillas', // Added by story 48861, to be cleaned up by story ?????
  optimizelyHierarchyFlip: 'optimizelyHierarchyFlip', // Added by story 52613, to be cleaned up by story ?????
  optimizelyResortFeeInSuiteCard: 'optimizelyResortFeeInSuiteCard', // Added by story 52749, to be cleaned up by story ?????
  optimizelySecureCheckout: 'optimizelySecureCheckout', // Added by story 51139, to be cleaned up by story ?????
  optimizelyAppleGoolePayOrder: 'optimizelyAppleGoolePayOrder', // Added by story 54809, to be cleaned up by story ?????
  optimizelyDisplayResortFeeWithTotalInSuiteCardH: 'optimizelyDisplayResortFeeWithTotalInSuiteCardH', // Added by story 57139, to be cleaned up by story ?????
  optimizelyDisplayResortFeeWithTotalInSuiteCardJ: 'optimizelyDisplayResortFeeWithTotalInSuiteCardJ', // Added by story 57624, to be cleaned up by story ?????
  optimizelyExpressCheckout: 'optimizelyExpressCheckout', // Added by story 61987 & 62104, to be cleaned up by story ?????
  optimizelyI4Iframe: 'optimizelyI4Iframe', // Added by story 62253, to be cleaned up by story ?????
  optimizelyDiningPageRedesign: 'optimizelyDiningPageRedesign', // Added by story 69517, to be cleaned up by story 75581
  optimizelyFamilyRates: 'optimizelyFamilyRates', // Added by story 74739, but change to the family rates story 75387 to be cleaned up by story ?????
  optimizelyFamilyRatesStepper: 'optimizelyFamilyRatesStepper', // Added by story 74739, to be cleaned up by story 77759,
  optimizelyHighlightWolfPass: 'optimizelyHighlightWolfPass' // Added by story 78998, to be cleaned up by story 79524,
};

/**
 * This is for tests that are located on multiple pages or components.
 * This array is to be empty by default.
 */
const MULTIPLE_TESTS_ACTIVE_LISTS = [];

/**
 *
 * @param {*} testName This is the name of the global variable that is set in Optimizely
 * @param {*} developMode This is a boolean that is set to true if you want to see the test in develop mode
 * @returns
 */
export const getTestValueAB = (testName, developMode = false) => {
  if (developMode) {
    return true;
  }
  if (isDevEnvironment && MULTIPLE_TESTS_ACTIVE_LISTS.includes(testName)) {
    return true;
  }

  return window[testName] || false;
};
